module.exports = __webpack_public_path__ + "img/daylight_3.9aeb1253.png";